<template>
	<div>
		<div v-if="$_hasAccessToFeature($FeatureId.POSITION_TEMPLATES_MANAGE, $PermissionAction.USE)">
			<v-card class="mb-4">
				<v-divider></v-divider>

				<v-snackbar v-model="snackbar.show" top :color="snackbar.color" :timeout="snackbar.timeout">
					{{ snackbar.message }}
					<v-btn :color="snackbar.buttonColor" flat @click="snackbar.show = false"> Close </v-btn>
				</v-snackbar>

				<v-card-text>
					<v-subheader> This section allows you to add {{ $term('positionTemplate', { plural: true }) }} that you might want to re-use in the future. </v-subheader>

					<v-footer color="" app height="55">
						<v-spacer></v-spacer>
						<footer-add-btn @click="onAddClick">Add New Template</footer-add-btn>
					</v-footer>

					<v-tabs v-model="active_tab">
						<v-tab class="noPrint">Active</v-tab>
						<v-tab class="noPrint">Archived</v-tab>

						<v-tab-item class="mt-4">
							<v-data-table disable-initial-sort :headers="headers" :items="positionTemplateList" hide-actions class="elevation-1">
								<template slot="items" slot-scope="props">
									<tr>
										<td class="text-xs-left">
											<router-link :to="{ name: 'positionTemplate', params: { id: props.item.id } }">
												{{ props.item.title }}
											</router-link>
										</td>
										<td class="text-xs-left">{{ props.item.department }}</td>
										<td class="text-xs-right px-0">
											<v-icon small class="mr-2" @click="editItem(props.item)"> edit </v-icon>

											<v-menu>
												<template #activator="{ on: menu }">
													<v-tooltip bottom>
														<template #activator="{ on: tooltip }">
															<v-icon v-on="{ ...tooltip, ...menu }" small class="mr-2"> more_vert </v-icon>
														</template>
														<span>More Options</span>
													</v-tooltip>
												</template>
												<v-list>
													<v-list-tile @click="onSend(props.item)">
														<v-list-tile-avatar>
															<v-icon>mail</v-icon>
														</v-list-tile-avatar>
														<v-list-tile-title>Send via Email</v-list-tile-title>
													</v-list-tile>
													<v-list-tile small @click="archiveItemClick(props.item)">
														<v-list-tile-avatar>
															<v-icon>archive</v-icon>
														</v-list-tile-avatar>
														<v-list-tile-title>Archive</v-list-tile-title>
													</v-list-tile>
													<v-list-tile small @click="deleteItemClick(props.item)">
														<v-list-tile-avatar>
															<v-icon>delete</v-icon>
														</v-list-tile-avatar>
														<v-list-tile-title>Delete</v-list-tile-title>
													</v-list-tile>
												</v-list>
											</v-menu>
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-tab-item>

						<v-tab-item class="mt-4">
							<v-data-table disable-initial-sort :headers="headers" :items="positionTemplateArchivedList" :loading="positionTemplatesArchived_loading || isUnarchiving" hide-actions class="elevation-1">
								<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
								<template slot="items" slot-scope="props">
									<tr>
										<td class="text-xs-left">
											<router-link :to="{ name: 'positionTemplate', params: { id: props.item.id } }">
												{{ props.item.title }}
											</router-link>
										</td>
										<td class="text-xs-left">{{ props.item.department }}</td>
										<td class="text-xs-right px-0">
											<v-icon title="Unarchive" small class="mr-2" @click="onUnarchive(props.item)"> undo </v-icon>

											<v-menu>
												<template #activator="{ on: menu }">
													<v-tooltip bottom>
														<template #activator="{ on: tooltip }">
															<v-icon v-on="{ ...tooltip, ...menu }" small class="mr-2"> more_vert </v-icon>
														</template>
														<span>More Options</span>
													</v-tooltip>
												</template>
												<v-list>
													<v-list-tile @click="onSend(props.item)">
														<v-list-tile-avatar>
															<v-icon>mail</v-icon>
														</v-list-tile-avatar>
														<v-list-tile-title>Send via Email</v-list-tile-title>
													</v-list-tile>
													<v-list-tile small @click="deleteItemClick(props.item)">
														<v-list-tile-avatar>
															<v-icon>delete</v-icon>
														</v-list-tile-avatar>
														<v-list-tile-title>Delete</v-list-tile-title>
													</v-list-tile>
												</v-list>
											</v-menu>
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-tab-item>
					</v-tabs>
				</v-card-text>

				<confirmation-dialog
					v-if="showConfirmDeleteDialog"
					:dialog="showConfirmDeleteDialog"
					:text="`Are you sure you want to delete this ${$term('positionTemplate')}?`"
					:isConfirming="isDeleting"
					@onConfirm="onDelete"
					@onCancel="showConfirmDeleteDialog = false"
				/>

				<confirmation-dialog
					v-if="showConfirmArchiveDialog"
					:dialog="showConfirmArchiveDialog"
					:text="`Are you sure you want to archive this ${$term('positionTemplate')}?`"
					:isConfirming="isArchiving"
					@onConfirm="onArchive"
					@onCancel="showConfirmArchiveDialog = false"
				/>

				<send-email-dialog
					v-if="showSendEmailDialog"
					:dialog="showSendEmailDialog"
					:title="`Email ${$term('positionTemplate', { case: 'title' })}`"
					:subject="$_getEmailMeta(loggedInEmployee, positionTemplateToSend).subject"
					:body="$_getEmailMeta(loggedInEmployee, positionTemplateToSend).body"
					@onCancel="showSendEmailDialog = false"
					@onSent="onSent"
				/>

				<create-position-template-modal v-if="showCreatePositionTemplateModal"
					:templates="globalPositionTemplates"
					:globalTemplatesInUse="globalPositionTemplateInUse"
					@onBlankTemplateSelected="onBlankTemplateSelected"
					@onTemplateSelected="onTemplateSelected"
					@closeModal="showCreatePositionTemplateModal = !showCreatePositionTemplateModal"
					/>

			</v-card>
		</div>
		<div v-else>You do not have access</div>
	</div>
</template>

<script>
	import { mapState, mapGetters } from 'vuex';
	import SendEmailDialog from '@/components/email/SendEmailDialog';
	import positionTemplateEmailMixin from '@/mixins/positionTemplateEmailMixin';
	import CreatePositionTemplateModal from '@/components/positionTemplate/CreatePositionTemplateModal';

	export default {
		components: {
			SendEmailDialog,
			CreatePositionTemplateModal
		},
		props: {
			previousAction: {
				type: String,
				required: false
			}
		},
		mixins: [positionTemplateEmailMixin],
		created() {
			this.$store.dispatch('setPageTitle', this.$term('positionTemplate', { plural: true, case: 'title' }));

			if (this.previousAction) {
				switch (this.previousAction) {
					case 'template_deleted':
						this.showSnackbar(`${this.$term('positionTemplate', { case: 'title' })} Deleted`);
						break;
					default:
						break;
				}
			}

			if (!this.positionTemplatesArchived_loaded) {
				this.$store.dispatch('positionTemplates/getArchived');
			}

			if (!this.globalPositionTemplates_loaded) {
				this.$store.dispatch('positionTemplates/getGlobalTemplates');
			}
		},
		data() {
			return {
				active_tab: 0,
				headers: [
					{ text: 'Position Title', value: 'title' },
					{ text: 'Department', value: 'department' },
					{ text: '', value: 'actions', sortable: false }
				],
				snackbar: {
					show: false,
					message: '',
					color: undefined,
					buttonColor: 'pink',
					timeout: 6000
				},
				showConfirmDeleteDialog: false,
				isDeleting: false,
				itemToDelete: null,
				showSendEmailDialog: false,
				positionTemplateToSend: null,
				showConfirmArchiveDialog: false,
				isArchiving: false,
				itemToArchive: null,
				isUnarchiving: false,
				showCreatePositionTemplateModal: false
			};
		},
		computed: {
			...mapGetters({
				positionTemplateList: 'positionTemplates/positionTemplateList',
				positionTemplateArchivedList: 'positionTemplates/positionTemplateArchivedList',
				loggedInEmployee: 'loggedInEmployee',
				globalPositionTemplates: 'positionTemplates/globalPositionTemplates',
				globalPositionTemplateInUse: 'positionTemplates/globalPositionTemplatesInUse'
			}),
			...mapState({
				positionTemplates_loading: (state) => state.positionTemplates.positionTemplates_loading,
				positionTemplatesArchived_loading: (state) => state.positionTemplates.positionTemplatesArchived_loading,
				positionTemplatesArchived_loaded: (state) => state.positionTemplates.positionTemplatesArchived_loaded,
				globalPositionTemplates_loading: (state) => state.positionTemplates.globalPositionTemplates_loading,
				globalPositionTemplates_loaded: (state) => state.positionTemplates.globalPositionTemplates_loaded
			})
		},
		methods: {
			onAddClick() {
				this.showCreatePositionTemplateModal = true;
			},
			editItem(item) {
				this.$router.push(`/positionTemplate/${item.id}/edit/`);
			},
			deleteItemClick(item) {
				this.itemToDelete = item;
				this.showConfirmDeleteDialog = true;
			},
			onDelete() {
				this.isDeleting = true;
				this.$store.dispatch('positionTemplates/delete', this.itemToDelete).then(
					(response) => {
						this.isDeleting = false;
						this.showConfirmDeleteDialog = false;
						this.showSnackbar(`${this.$term('positionTemplate', { case: 'title' })} Deleted`);
					},
					(error) => {
						this.isDeleting = false;
						this.showSnackbar(`The ${this.$term('positionTemplate', { case: 'title' })} could not be deleted at this time`);
					}
				);
			},
			archiveItemClick(item) {
				this.itemToArchive = item;
				this.showConfirmArchiveDialog = true;
			},
			onArchive() {
				this.isArchiving = true;
				this.$store.dispatch('positionTemplates/archive', this.itemToArchive.id).then(
					(response) => {
						this.isArchiving = false;
						this.showConfirmArchiveDialog = false;
						this.showSnackbar(`${this.$term('positionTemplate', { case: 'title' })} '${this.itemToArchive.title}' Archived`);
					},
					(error) => {
						this.isArchiving = false;
						this.showSnackbar(`The ${this.$term('positionTemplate', { case: 'title' })} could not be archived at this time`);
					}
				);
			},
			onUnarchive(item) {
				this.isUnarchiving = true;
				this.$store.dispatch('positionTemplates/unarchive', item.id).then(
					(response) => {
						this.isUnarchiving = false;
						this.showSnackbar(`${this.$term('positionTemplate', { case: 'title' })} '${item.title}' Unarchived`);
					},
					(error) => {
						this.isUnarchiving = false;
						this.showSnackbar(`The ${this.$term('positionTemplate', { case: 'title' })} could not be unarchived at this time`);
					}
				);
			},
			onSend(positionTemplate) {
				this.positionTemplateToSend = positionTemplate;
				this.showSendEmailDialog = true;
			},
			onSent() {
				this.showSendEmailDialog = false;
				this.showSnackbar(`${this.$term('positionTemplate', { case: 'title' })} sent`);
			},
			showSnackbar(message, isError) {
				this.snackbar.show = true;
				this.snackbar.message = message;
				this.snackbar.color = isError ? 'error' : undefined;
				this.snackbar.buttonColor = isError ? '#fff' : 'pink';
				this.snackbar.timeout = isError ? 0 : 6000;
			},
			onBlankTemplateSelected() {
				this.$router.push('/positionTemplate/create/');
			},
			onTemplateSelected(template) {
				this.$store.dispatch('positionTemplates/useGlobalTemplate', template).then(
					response => {
						this.$router.push({ name: 'positionTemplate', params: { id: response.id, previousAction: 'position_template_created' }});
					},
					err => {}
				);
			}
		}
	};
</script>

<style></style>
